<template>
	<div v-loading="loading">
		<slot :data='scopeData' :items="cartData"></slot>
	</div>
</template>

<script>
    export default {
        //props: cartData {items[],cartId}, user_id
        mounted(){
            let vm = this;

            if(window.localStorage.getItem('cartId')!==null){
                this.cartId = parseInt(window.localStorage.getItem('cartId'));
                this.getCart();
            }

            kinfEvents.$on('FundingChange',ev=>{
                vm.changeFunding(ev);
            });

            kinfEvents.$on('removeFundraiserDonation',ev=>{
                vm.removeFundraiserDonation(ev);
            });

            kinfEvents.$on('AddItemToCart',ev=>{
                vm.cartData[ev.fundraiser_id]=ev;
                kinfEvents.$emit('CartUpdated')
            });

            kinfEvents.$on('refreshCart',ev=>{
                this.getCart();
            });

            kinfEvents.$on("CartCreated",ev=>{
                vm.cartId = ev;
                vm.getCart(ev);
            });

            kinfEvents.$on('PaymentSuccess',ev=>{
                console.log(ev);
                localStorage.clear();
                this.donor = ev.data.data.donor;
                this.currentStep = 2;
            });

            kinfEvents.$on('PaymentError',ev=>{
                console.log(ev);
                if(ev.response.data.data.has_invalid_items){
                    console.log(ev.response.data.data.items);
                    this.cartData = ev.response.data.data.items;
                }
                this.$Modal.error({
                    title: "Transaction Error",
                    content: ev.response.data.response.message
                });
            });

        },
        data() {
            return {
                donor:{
                    email:null,
                    id:null,
                    isNew:false,
                },
                cartId: null,
                currentStep: 1,
                cartData:[],
                loading:false,
            };
        },
        computed: {
            scopeData() {
                return {
                    currentStep: this.currentStep,
                    cartData: this.cartData,
                    cartId: this.cartId,
                    tableLoading: this.loading,
                    facebookLink: this.getFacebookLink(),
                    twitterLink: this.getTwitterLink(),
                    donor: this.donor
                }
            }
        },
        methods:{
            getCart(id) {
                let cartId = id === undefined ? window.localStorage.getItem('cartId') : id;
                let cartRoute = window.App.globalData.routes.show_cart.replace("ID", cartId);
                axios.get(cartRoute).then(response => {
                    this.cartData = response.data.items;
                }).catch(e =>{
                    console.log(e);
                    window.localStorage.clear();
                    this.cartId = null;
                });
            },
            changeFunding(fundingData){
                let id = this.cartData[fundingData.fundraiserSlug].fundraiser_id;
                let route = window.App.globalData.routes.update_item_from_cart.replace("ID",this.cartId);
                this.loading=true;
                axios.put(route,{
                    amount:fundingData.amount,
                    fundraiser_id:id,
                }).then(response=>{
                    this.loading = false;
                    this.cartData[fundingData.fundraiserSlug].current_donation = fundingData.amount;
                }).catch(e=>{
                    this.loading = false;
                    console.log(e.response);
                    this.$notify({
                        title: 'Error',
                        message: e.response.data.response.message,
                        type: 'error'
                    });
                });
            },
            removeFundraiserDonation(id){
                /* here axios call to remove fundraiser donation */
                this.loading=true;
                let route = window.App.globalData.routes.remove_item_from_cart.replace("ID",this.cartId);
                axios.patch(route,{fundraiser_id:id}).then(response=>{
                    this.loading=false;
                    this.getCart();
                    // delete this.cartData[parseInt(id)];
                    // kinfEvents.$emit('CartUpdated');
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });
                }).catch(e=>{
                    this.loading = false;
                    console.log(e.response);
                    this.$notify({
                        title: 'Error',
                        message: e.response.data.response.message,
                        type: 'error'
                    });
                });
            },
            getTwitterLink() {
                // let url = 'https://twitter.com/intent/tweet?';

                // url += 'text=I just helped classrooms across the country get the school supplies they need from SupplyAClassroom.org! You can help, too. #ClassroomSupplyBox';
                // url += '&url=SupplyAClassroom.org';

                const url = 'https://www.twitter.com/intent/tweet?text=I just provided an under-resourced teacher a semester’s worth of essential school supplies through @KidsInNeed. I believe every child in America should have equal opportunity and access to a quality education. Will you join me? https://tinyurl.com/y6d9j8a7'
                // const url = 'https://www.twitter.com/intent/tweet?text=I just provided an under-resourced teacher a semester’s worth of essential school supplies through @KidsInNeed. I believe every child in America should have equal opportunity and access to a quality education. Will you join me? https://tinyurl.com/y6d9j8a7'

                return url;
            },
            getFacebookLink() {
                // const url = 'https://www.facebook.com/sharer/sharer.php?u=supplyateacher.org';
                // let url = 'https://www.facebook.com/sharer/sharer.php?u=SupplyAClassroom.org';


                return 'https://www.facebook.com/sharer/sharer.php?u=supplyateacher.org';
            },
        }
    }


</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/PageCheckout.vue